import React from 'react';
import { PageWrapper } from '../../Styles/style';
import SmoothScroll from '../../Components/GsapSmoothScroll';
import CYAHeader from '../../Sections/CYA/S1-CYA';
import FooterCYA from '../../Sections/CYA/S2-Footer';
import LockerMenu from '../../Components/LockerMenu';


const CreateAccount = () => {
  return (
    <PageWrapper>
        <LockerMenu/>
        <CYAHeader/>
        <FooterCYA/>
    </PageWrapper>
   
  );
};

export default CreateAccount;
